import { z } from 'zod';
import { assetRefSchema } from './catalog';
import { uuidSchema } from './common';
import { LANDING_MOVE_DIRECTIONS } from './landing';

// ---------------------------------------------------------------------------
// 추천 상품(products.recommended_rank) 관리 계약 — ADMIN 랜딩 페이지 화면 전용(adminProcedure).
// 설계: docs/superpowers/specs/2026-09-22-landing-recommended-portfolio-design.md §5-1
// ---------------------------------------------------------------------------

export const addRecommendedProductInputSchema = z.strictObject({ productId: uuidSchema });
export type AddRecommendedProductInput = z.infer<typeof addRecommendedProductInputSchema>;

export const removeRecommendedProductInputSchema = z.strictObject({ productId: uuidSchema });
export type RemoveRecommendedProductInput = z.infer<typeof removeRecommendedProductInputSchema>;

export const moveRecommendedProductInputSchema = z.strictObject({
  productId: uuidSchema,
  direction: z.enum(LANDING_MOVE_DIRECTIONS),
});
export type MoveRecommendedProductInput = z.infer<typeof moveRecommendedProductInputSchema>;

/** 어드민 목록 항목 — 배열 순서가 HOME 노출 순서다. */
export const recommendedProductAdminSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  thumbnail: assetRefSchema.nullable(),
  recommendedRank: z.number().int(),
});
export type RecommendedProductAdmin = z.infer<typeof recommendedProductAdminSchema>;
export const recommendedProductAdminListSchema = z.array(recommendedProductAdminSchema);
